import { combineReducers } from '@reduxjs/toolkit';

import {
    allowAddressDeletionReducer,
    appNameReducer,
    authDevicesReducer,
    domainsAddressesReducer,
    memberAuthDevicesReducer,
    mspSubsidiariesReducer,
    passwordPoliciesReducer,
    retentionPoliciesReducer,
    safetyReviewTelemetryReducer,
    samlReducer,
    userOrganizationsReducer,
} from '@proton/account';
import { oauthTokenReducer } from '@proton/activation/src/logic/oauthToken';
import { calendarsBootstrapReducer } from '@proton/calendar/calendarBootstrap';
import { calendarSettingsReducer } from '@proton/calendar/calendarUserSettings';
import { calendarsReducer } from '@proton/calendar/calendars';
import { holidaysDirectoryReducer } from '@proton/calendar/holidaysDirectory';
import { filtersReducer } from '@proton/mail/store/filters';
import { incomingAddressForwardingsReducer } from '@proton/mail/store/forwarding/incoming';
import { outgoingAddressForwardingsReducer } from '@proton/mail/store/forwarding/outgoing';
import { sharedReducers } from '@proton/redux-shared-store/sharedReducers';

export const rootReducer = combineReducers({
    ...sharedReducers,
    ...passwordPoliciesReducer,
    ...filtersReducer,
    ...incomingAddressForwardingsReducer,
    ...outgoingAddressForwardingsReducer,
    ...domainsAddressesReducer,
    ...calendarSettingsReducer,
    ...calendarsReducer,
    ...calendarsBootstrapReducer,
    ...holidaysDirectoryReducer,
    ...samlReducer,
    ...allowAddressDeletionReducer,
    ...authDevicesReducer,
    ...memberAuthDevicesReducer,
    ...oauthTokenReducer,
    ...retentionPoliciesReducer,
    ...mspSubsidiariesReducer,
    ...userOrganizationsReducer,
    ...appNameReducer,
    ...safetyReviewTelemetryReducer,
});

export type AccountState = ReturnType<typeof rootReducer>;
